// Presence banner — plan §4.4.1 concurrent edit.
// SSE ile başka kullanıcı algılanırsa üstte banner. Kopya `lib/presence-copy.ts` (Finar rev-A 18:
// ada ek getirmeyen cümle, metin kırmızı).

import type { PresenceUser } from "@mahir/shared";
import { presenceBannerParts } from "../../lib/presence-copy";

interface Props {
  others: PresenceUser[];
}

export function PresenceBanner({ others }: Props): JSX.Element | null {
  const parts = presenceBannerParts(others.map((o) => o.fullName));
  if (!parts) return null;
  return (
    <div
      className="px-4 py-2 text-sm"
      data-testid="presence-banner"
      style={{
        background: "color-mix(in srgb, var(--color-warning) 8%, white)",
        color: "var(--color-error)",
        borderBottom: "1px solid color-mix(in srgb, var(--color-warning) 35%, white)",
        textAlign: "center",
      }}
    >
      {parts.lead} <strong>{parts.names}</strong> {parts.tail}
    </div>
  );
}
